import React from 'react';
import { useParams } from 'react-router-dom';
import { StandardProductView } from '../components/product/StandardProductView';
import { SystemBuilderView } from '../components/product/SystemBuilderView';
import { getProduct } from '../utils/products';
import { NotFound } from './NotFound';
export function Product() {
  const {
    id
  } = useParams();
  const product = getProduct(id);
  if (!product) return <NotFound data-id="element-757" data-mp="3dnrhkxo2dugf" />;
  return product.template === 'system' ? <SystemBuilderView key={product.id} product={product} data-id="element-758" data-mp="3dl5a0y16bey7" /> : <StandardProductView key={product.id} product={product} data-id="element-759" data-mp="3imkt4kjsjbdy" />;
}